// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form___aCZp","forgot":"LoginForm_forgot__1HpA9","signIn":"LoginForm_signIn__3vwOm","subtitle":"LoginForm_subtitle__2t_1t"};